<div class="magic-link-verify-container">
  <div class="magic-link-verify-content">
    @if(loading) {
      <div class="magic-link-verify-loader">
        <div class="loader-spinner"></div>
        <div class="magic-link-verify-text">Verifying magic link...</div>
      </div>
    }

    @if(error) {
      <div class="magic-link-verify-error">
        <div class="magic-link-verify-error-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#CC0000"/>
          </svg>
        </div>
        <div class="magic-link-verify-error-title">Verification Failed</div>
        <div class="magic-link-verify-error-text">{{ error }}</div>
        <button
          class="magic-link-verify-button"
          [routerLink]="['/magic-link']"
        >REQUEST NEW LINK</button>
        <button
          class="magic-link-verify-button dark-button"
          [routerLink]="['/login']"
        >BACK TO LOGIN</button>
      </div>
    }
  </div>
</div>
